import {createSlice} from '@reduxjs/toolkit'
import {RecreacionModel} from '../../models'

export const EmptyRecreacionState: RecreacionModel = {
  showPanel: false,
  tabs: [
    {
      id: 0,
      title: 'Inicio',
      showPanel: false,
      idToEdit: '',
      idToDelete: '',
      loadingTable: false,
      content: {
        headerPanel: '',
        detailPanel: '',
      },
      submenu: 'start',
      closable: false,
      reset: false,
      aditionalInformation: null,
    },
  ],
  currentTab: 0,
}

export const recreacionSlice = createSlice({
  name: 'recreacion',
  initialState: EmptyRecreacionState,
  reducers: {
    addTabAction: (state, action) => {
      return {...state, tabs: [...state.tabs, action.payload]}
    },
    deleteTabAction: (state, action) => {
      return {...state, tabs: action.payload}
    },
    changeTabAction: (state, action) => {
      return {...state, currentTab: action.payload}
    },
    setCurrentTabItemAction: (state, action) => {
      return {
        ...state,
        tabs: state.tabs.map((tab, idx) =>
          idx === state.currentTab ? {...tab, ...action.payload} : tab
        ),
      }
    },
    resetCentral: () => {
      return EmptyRecreacionState
    },
  },
})

export const {
  addTabAction,
  deleteTabAction,
  changeTabAction,
  setCurrentTabItemAction,
  resetCentral,
} = recreacionSlice.actions

export default recreacionSlice.reducer
